import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Top Shelf", href: "#top-shelf" },
  { label: "Journal", href: "#journal" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "nav-blur" : ""}`}
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <svg width="28" height="28" viewBox="0 0 40 40" fill="none">
            <path d="M8 8 L20 32 L32 8" stroke="var(--brass)" strokeWidth="1.4" />
            <circle cx="20" cy="20" r="3" fill="var(--amber)" />
          </svg>
          <span className="font-display text-[1.15rem] tracking-wide">Johnny Dram</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="eyebrow hover:text-amber-500 transition-colors"
              style={{ color: "var(--bone-dim)" }}
            >
              <span className="hover:text-[var(--amber)]">{l.label}</span>
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="#newsletter"
            data-testid="nav-cta"
            className="hidden md:inline-flex btn-outline"
          >
            Join the Order
          </a>
          <button
            data-testid="nav-toggle-mobile"
            className="md:hidden text-bone"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden nav-blur border-t"
            style={{ borderColor: "var(--hairline)" }}
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                  className="eyebrow"
                  style={{ color: "var(--bone)" }}
                >
                  {l.label}
                </a>
              ))}
              <a href="#newsletter" onClick={() => setOpen(false)} className="btn-outline w-fit" data-testid="nav-mobile-cta">
                Join the Order
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
